/**
 * Mapping of raw 0x API `provider` / `bridge` strings to display names.
 *
 * The provider list is sourced from the 0x supported-providers page.
 * Both snake_case and kebab-case variants are included because the API does not specify. TODO: Confirm this.
 *
 * @see https://0x-docs.gitbook.io/0x-cross-chain-api-beta/developer-resources/supported-chains-and-providers
 */
const BRIDGE_PROVIDERS: Record<string, string> = {
  'relay': 'Relay',
  'stargate-v2': 'Stargate V2',
  'stargate_v2': 'Stargate V2',
  'stargate': 'Stargate',
  'across': 'Across',
  'across_v4': 'Across',
  'arbitrum-bridge': 'Arbitrum Bridge',
  'arbitrum_bridge': 'Arbitrum Bridge',
  'bungee_auto': 'Bungee',
  'circle_forwarder_standard': 'Circle CCTP',
  'circle_forwarder_fast': 'Circle CCTP',
  'gaszip': 'Gas.zip',
  'gas.zip': 'Gas.zip',
  'gas_zip': 'Gas.zip',
  'linea': 'Linea',
  'mayan': 'Mayan',
  'mayan_swift': 'Mayan (Swift)',
  'mayan_mctp': 'Mayan (MCTP)',
  'mayan_fast_mctp': 'Mayan (FastMCTP)',
  'near_intents': 'NEAR Intents',
  'oft': 'LayerZero OFT',
  'squid': 'Squid',
  'squid_coral': 'Squid',
  'superchain': 'Superchain',
  'cctp': 'CCTP',
  'cctp-v2': 'CCTP',
  'symbiosis': 'Symbiosis',
  'synapse': 'Synapse',
  'hop': 'Hop',
  'celer': 'Celer',
  'hyphen': 'Hyphen',
};

/**
 * Resolve a raw 0x API provider string to a human-readable display name.
 * Falls back to replacing underscores with spaces for unknown providers.
 * Returns an empty string when the provider is undefined (e.g. for swap/wrap steps).
 */
export const getBridgeDisplayName = (provider: string | undefined): string => {
  if (!provider) return '';
  return BRIDGE_PROVIDERS[provider] ?? provider.replace(/_/g, ' ');
};
